<template>
  <v-dialog
    :color="$app.opts.modalHeaderColor"
    :value="true"
    @keydown.esc="dismiss"
    @input="(v) => dismiss()"
    scrollable
    :max-width="$app.opts.modalSizeDefault"
    persistent
  >
    <actions-list :flow-id="flowId" v-if="current" :dismiss="dismiss" />
    <v-card v-else>
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { Modal } from '@argon/app/mixins'
import { NAMESPACE } from '../store'
import { ActionsList } from '../components'

export default {
  name: 'ActionsListModal',
  mixins: [Modal],
  components: { ActionsList },
  props: {
    flowId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      returnPath: { name: 'flow' }
    }
  },
  computed: {
    ...mapState(NAMESPACE, ['current']),
    items() {
      return this.current.meta.actions
    }
  }
}
</script>
